import './Footer.css';
const Footer = () => {

    const handlerCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
           
            alert('Copiado!');
        } catch (err) {
            
        }
    
  }
    return(
        <footer>
            <div onClick={()=>handlerCopy('Rua Ponta Porã 447 Lapa 05058-000 Zona Oeste SP')} className='address'>
                <p>Rua Ponta Porã 447 • Lapa<br/>05058-000 • Zona Oeste • SP</p>
            </div>
            <div className='social'>
                <div className='social-wrapper'>
                    <a href={'https://wa.me/message/3FRX475ISS6GH1'} target={"_blank"}><i className='fa-brands fa-whatsapp'></i></a>
                    <label>11 97130 7368</label>
                </div>
                <div onClick={()=>handlerCopy('zupaestudio@gmail.com')} className='social-wrapper'>
                    <i className='fa-regular fa-envelope'></i>
                    <label>zupaestudio@gmail.com</label>
                </div>
                <div className='social-wrapper'>
                    <a href={'https://instagram.com/estudiozupa'} target={"_blank"}><i className='fa-brands fa-instagram'></i></a>
                    <label>@estudiozupa</label>
                </div>
            </div>
        </footer>
    )
};
export default Footer;